<script setup>
import { Icon, Button } from "@components"

import { useRoute } from 'vue-router'
const route = useRoute()

import { useChatCustomizer } from '@store/chatCustomizer'
const $chatCustomizer = useChatCustomizer()


import { useSettings } from '@store/settings'
const $settings = useSettings()

// import { isLg, isXl } from '@utils/mediaQuery'

const pageTitle = () => {
    return route.meta.title || ''
}

const saveSettings = async () => {
    await $settings.saveSettings('chat-widget')
    console.log('Settings saved')
    // $chatCustomizer.isCustomizerChanged = false
    Toast.success('Customizer updated successfully')
}
</script>

<template>
    <div class="h-[76px] border-b border-[#D0D5DD] py-[18px] pr-[52px] pl-[22px] flex items-center justify-between bg-white" :style="`padding-left:${$chatCustomizer.sidebarWidth}`">
        <div class="flex items-center gap-5 text-[#101828] text-lg font-semibold" :class="{ 'pl-5': !$settings.isRTL }">{{ pageTitle() }}</div>

        <div class="flex gap-3 items-center" :class="{ 'pl-5': $settings.isRTL }">
            <!-- <Button size="lg" type="tertiary_gray" radius="square" class="text-[#475467]" @click="$chatCustomizer.resetCustomizer">
                <Icon name="repeat04" size="20px" class="text-[#F79009]"></Icon> Reset
            </Button> -->
            <!-- <Button size="lg" type="secondary_gray" radius="square" :classButton="'h-[38px] !text-base'">Live Demo</Button> -->
            <!-- <Button size="lg" type="secondary_gray" radius="square" :classButton="'h-[38px] !text-base'">Auto Generate</Button> -->
            <Button size="md" type="primary" radius="square" :classButton="'h-[38px]'" @click="saveSettings">Publish</Button>
        </div>
    </div>
</template>